// Country list with zone mapping for shipping rate lookup
var countries = [
  { name: "Guyana", zone: "Guyana" },
  { name: "Trinidad and Tobago", zone: "Caribbean" },
  { name: "Barbados", zone: "Caribbean" },
  { name: "Jamaica", zone: "Caribbean" },
  { name: "Suriname", zone: "Caribbean" },
  { name: "Bahamas", zone: "Caribbean" },
  { name: "Grenada", zone: "Caribbean" },
  { name: "Saint Lucia", zone: "Caribbean" },
  { name: "Dominica", zone: "Caribbean" },
  { name: "Antigua and Barbuda", zone: "Caribbean" },
  { name: "Saint Vincent and the Grenadines", zone: "Caribbean" },
  { name: "Saint Kitts and Nevis", zone: "Caribbean" },
  { name: "Belize", zone: "Caribbean" },
  { name: "United States", zone: "North America" },
  { name: "Canada", zone: "North America" },
  { name: "Mexico", zone: "North America" },
  { name: "United Kingdom", zone: "International" },
  { name: "Germany", zone: "International" },
  { name: "France", zone: "International" },
  { name: "Netherlands", zone: "International" },
  { name: "Brazil", zone: "International" },
  { name: "Australia", zone: "International" },
  { name: "Japan", zone: "International" },
  { name: "India", zone: "International" },
  { name: "Nigeria", zone: "International" },
  { name: "South Africa", zone: "International" },
  { name: "Ghana", zone: "International" },
  { name: "China", zone: "International" },
  { name: "Other", zone: "International" },
];

export function getCountryList() {
  return countries.map(function(c) { return c.name; });
}

export function getZoneForCountry(countryName) {
  var match = countries.find(function(c) {
    return c.name.toLowerCase() === countryName.toLowerCase();
  });
  return match ? match.zone : "International";
}

export default countries;